import { render, staticRenderFns } from "./userExtraConfigBox.vue?vue&type=template&id=d3b5a4ec"
import script from "./userExtraConfigBox.vue?vue&type=script&lang=js"
export * from "./userExtraConfigBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports